<ngx-spinner [name]="'gerenciar-promocoes'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Gerenciar Promoções</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <form [formGroup]="promocoesForm">

            <div class="row" *ngIf="!bCadastroConsulta">
                <div class="col-sm text-right">
                    <button mat-flat-button color="primary" (click)="novoGrupoPromocional()">
                        <mat-icon>add</mat-icon> Novo grupo
                    </button>
                </div>
            </div>

            <div class="row mt-4" *ngIf="!bCadastroConsulta">
                <div class="col-sm">
                    <table mat-table [dataSource]="gruposPromocoesSource" class="mat-elevation-z2">

                        <ng-container matColumnDef="Nome">
                            <th mat-header-cell *matHeaderCellDef> Nome do grupo </th>
                            <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Produtos">
                            <th mat-header-cell *matHeaderCellDef> Produtos </th>
                            <td mat-cell *matCellDef="let element"> {{element.ProdutosString}} </td>
                        </ng-container>

                        <ng-container matColumnDef="QuantidadeMinima">
                            <th mat-header-cell *matHeaderCellDef> Quantidade mínima </th>
                            <td mat-cell *matCellDef="let element"> {{element.QuantidadeMinima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Status">
                            <th mat-header-cell *matHeaderCellDef> Statusa </th>
                            <td mat-cell *matCellDef="let element"> {{element.Status ? 'Ativado' : 'Desativado'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="AtivarDesativar">
                            <th mat-header-cell *matHeaderCellDef> Ativar / Desativar </th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button matTooltip="Editar"
                                    (click)="ativarDesativarGrupo(element)" class="iconbutton"
                                    color="primary">
                                    <mat-icon aria-label="Editar">edit</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                        </tr>

                        <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="5" style="text-align: center;">Não há grupos com descontos
                                cadastrados
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

            <div *ngIf="bCadastroConsulta">
                <div class="row mt-4">
                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Nome do grupo</mat-label>
                            <input type="text" matInput formControlName="nomeGrupo" required maxlength="100">
                            <mat-error *ngIf="f.nomeGrupo.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-auto">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Quantidade mínima de itens</mat-label>
                            <input type="number" matInput formControlName="quantidadeMinima" required maxlength="100">
                            <mat-error *ngIf="f.quantidadeMinima.errors">
                                Campo obrigatório
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm">
                        <mat-form-field appearance="outline" [floatLabel]="'always'">
                            <mat-label>Descrição (Nome do Produto)</mat-label>
                            <input type="text" matInput formControlName="nomeProduto" maxlength="100"
                                (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                                (ngModelChange)="onChangeNomeProduto($event)">
                            <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são
                                permitidos
                                acentos ou
                                caracteres especiais </mat-hint>
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let prod of produtos" [value]="prod.Nome"
                                (onSelectionChange)="adicionarProduto(prod)">
                                {{prod.Codigo}} - {{prod.Nome}} - {{prod.ValorString}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-sm">
                        <table mat-table [dataSource]="produtosSource" class="mat-elevation-z2">

                            <ng-container matColumnDef="Codigo">
                                <th mat-header-cell *matHeaderCellDef> Código do produto </th>
                                <td mat-cell *matCellDef="let element"> {{element.Codigo}} </td>
                            </ng-container>

                            <ng-container matColumnDef="NomeProduto">
                                <th mat-header-cell *matHeaderCellDef> Nome </th>
                                <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                            </ng-container>

                            <ng-container matColumnDef="Remover">
                                <th mat-header-cell *matHeaderCellDef> Remover </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button matTooltip="Remover" (click)="removerProduto(element)"
                                        class="iconbutton" color="primary">
                                        <mat-icon aria-label="Remover">close</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns_produtos"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns_produtos;">
                            </tr>

                            <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="5" style="text-align: center;">Não há produtos adicionados
                                    ao
                                    grupo
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="row mt-4" *ngIf="bCadastroConsulta">
                <div class="col-sm">
                    <mat-divider></mat-divider>
                </div>
            </div>


            <div class="row mt-4" *ngIf="bCadastroConsulta">
                <div class="col-auto">
                    <button mat-flat-button color="warn" (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon> Voltar
                    </button>
                </div>

                <div class="col-sm text-right">
                    <button mat-flat-button color="primary" (click)="cadastrarGrupo()">
                        <mat-icon>check</mat-icon> Salvar
                    </button>
                </div>
            </div>

        </form>
    </mat-card-content>
</mat-card>